import React from "react";
import PropTypes from "prop-types";
import useFilterTracking from "../../shared/tracking/useFilterTracking";
import "./toggleableButton.scss";

function ToggleableButton(props) {
  const { isActive, isRadio, title } = props;

  // Toggles fire "Filter Option Changed" with options ["On"]/["Off"] on every flip.
  const { containerRef, trackToggle } = useFilterTracking({});

  const handleOnClick = () => {
    const nextActive = !isActive;
    props.onClick(nextActive);
    if (isRadio) {
      trackToggle(nextActive ? "On" : "Off");
    }
  };

  return (
    <>
      {isRadio ? (
        <span className="radio-button-root" ref={containerRef}>
          <input
            type="checkbox"
            className="ios8-switch"
            id={"section-toggle-" + title.toLowerCase()}
            checked={isActive}
            data-testid={title}
            onChange={handleOnClick}
          />
          <label htmlFor={"section-toggle-" + props.title.toLowerCase()} />
        </span>
      ) : (
        <button
          className={`toggleable-button-root ${isActive && "active"}`}
          onClick={handleOnClick}
        >
          {typeof props.render === "function" ? props.render(isActive) : props.label}
        </button>
      )}
    </>
  );
}

ToggleableButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  render: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  isActive: PropTypes.bool,
  isRadio: PropTypes.bool,
  title: PropTypes.string
};

ToggleableButton.defaultProps = {
  isActive: false,
  render: null,
  label: null,
  isRadio: false,
  title: ""
};

export default ToggleableButton;
